// Action Types
export const CHANGE_LANGUAGE_TO_EN = "CHANGE_LANGUAGE_TO_EN";
export const CHANGE_LANGUAGE_TO_RU = "CHANGE_LANGUAGE_TO_RU";
export const CHANGE_LANGUAGE_TO_BE = "CHANGE_LANGUAGE_TO_BE";
